import React from "react"

import { TResolvedTextMediaGroup } from "@/lib/kontent/components/getTextMediaGroup"

import { CardList } from "./CardList"

type TCardListResolverProps = {
  resolvedData: TResolvedTextMediaGroup
  titleCenter?: boolean
  variant: "article" | "component"
  even?: boolean
  isHomepage?: boolean
}

const CardListResolver = ({
  resolvedData,
  titleCenter = false,
  variant,
  even,
  isHomepage = false,
}: TCardListResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    titleCenter: titleCenter,
    backgroundDark: (variant !== "article" && even === false) || isHomepage,
    smallInfo: resolvedData.smallInfo,
    list: resolvedData.textBlocks.map((block) => {
      return {
        title: block.title,
        body: block.text,
        src: block.image?.url,
        alt: block.image?.description,
        imagePosition: block.imagePosition,
        variant:
          block.textBackground === "Light"
            ? ("neutral" as const)
            : ("primary" as const),
        clamp: false,
      }
    }),
    buttons: resolvedData.button ? [resolvedData.button] : undefined,
    footerText: resolvedData.smallInfo,
    variant: variant,
  }

  return <CardList {...kontentData} />
}

export { CardListResolver, type TCardListResolverProps }
